import { Component, ViewChild, OnInit, Input, AfterViewInit } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { IPadHistory } from '../../models/ipadhistory-model'
import { IPadPDF } from '../../models/ipadhistory-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { MemberIPadService } from '../../gateways/enrollment-data-service'
import { Router } from '@angular/router'
import { ExcelService } from '../../excel.service'
import * as moment from 'moment'
import * as _ from 'lodash'
import { JqxGridVirtualPaging } from '../../../../app/common/utilclasses/jqxgrid-virtualpaging'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'ipadhistory',
    templateUrl: 'ipadhistory-component.html'
})
export class ClsIPadHistory implements OnInit, AfterViewInit {
    public loading = false
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent
    @Input()
    IPadHistory: IPadHistory[]
    IPadPDF: IPadPDF[]
    jqx: any
    data: any = []
    memberService: IPadHistory
    memberServicePDF: IPadPDF
    gridwidth: number = 1240
    gridheight: number = 350
    IsrecordFound: boolean
    serviceResponse: string
    downloadError: string
    filename: string
    totalCount: number | undefined
    chunkSize: number = 10000
    jqxGridVirtualPaging: JqxGridVirtualPaging
    skipCall: boolean
    currentUser: CurrentUser

    source: any = {
        datafields: [
            { name: 'PreEnrollmentId', type: 'number' },
            { name: 'BeneficiaryName', type: 'string' },
            { name: 'EmailAddress', type: 'string' },
            { name: 'AgentId', type: 'string' },
            { name: 'ApplicationDate', type: 'date' },
            { name: 'PlanYear', type: 'string' },
            { name: 'ConfirmationNumber', type: 'string' }
        ],
        dataType: 'json',
        id: 'PreEnrollmentId',
        localData: this.data
    }
    dataAdapter: any = new jqx.dataAdapter(this.source)
    detailRenderer = function (row, columnfield, value, id) {
        return '<div class="jqx-grid-cell-left-align"><a class="link-button link download-pdf">Download</a></div>'
    }
    selectionmode: 'singlecell'
    columns: any[] = [
        { text: 'Beneficiary Name', datafield: 'BeneficiaryName', width: 220 },
        { text: 'Beneficiary Email', datafield: 'EmailAddress', width: 250 },
        { text: 'Agent Id', datafield: 'AgentId', width: 150 },
        { text: 'Date Created', datafield: 'ApplicationDate', width: 180, allowFilterable: 'false' },
        { text: 'Plan Year', datafield: 'PlanYear', width: 100 },
        { text: 'Confirmation Number', datafield: 'ConfirmationNumber', width: 190 },
        {
            text: 'Download',
            datafield: 'PreEnrollmentId',
            width: 130,
            cellsalign: 'center',
            editable: false,
            cellsRenderer: this.detailRenderer,
            allowFilterable: 'false'
            //  http://agentportal.SIT1a.meddweb.net/enroll/pdf.aspx?type=iPadEnrollmentsWithSOAAndDigitalSig&cid=168258&conf=SS180117IW0002
        }
    ]
    Cellclick(event: any): void {
        if (event.args.datafield === 'PreEnrollmentId') {
            this.downloadPDFIPad(event.args.row.bounddata.ConfirmationNumber, event.args.row.bounddata.PreEnrollmentId)
        }
    }
    constructor(
        private excelService: ExcelService,
        private gateway: EnrollmentGateway,
        public router: Router,
        private membermailservice: MemberIPadService,
        private currentUserGateway: CurrentUserGateway,
        private _globals: PortalGlobals
    ) {
        ;(this.memberService = {} as IPadHistory), (this.memberServicePDF = {} as IPadPDF), (this.jqxGridVirtualPaging = new JqxGridVirtualPaging())
    }

    loadCurrentUser(): void {
        if (this._globals !== undefined && this._globals.currentUser !== undefined) {
            this.currentUser = this._globals.currentUser
        } else {
            this.currentUserGateway.getCurrentUser().subscribe(
                (user: CurrentUser) => {
                    this.currentUser = user
                },
                (error) => {
                    console.log(error)
                }
            )
        }
    }

    loadIPadHistory() {
        if (this.currentUser.AetnaInd) {
            this.gateway.GetAllPWIPadHistory(this.memberService).subscribe(
                (summary) => {
                    if (summary.length > 0) {
                        this.totalCount = this.source.totalCount = summary[0].RowCount
                        this.IPadHistory = summary
                        this.source.localdata = summary
                        this.source.totalrecords = summary[0].RowCount
                        this.dataAdapter.dataBind()
                        this.myGrid.updatebounddata()
                        this.skipCall = false
                    } else {
                        this.totalCount = this.source.totalCount = 0
                        this.source.localdata = ''
                        this.source.totalrecords = 0
                        this.dataAdapter.dataBind()
                        this.myGrid.updatebounddata()
                    }
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                }
            )
        } else {
            this.gateway.GetAllIPadHistory(this.memberService).subscribe(
                (summary) => {
                    if (summary.length > 0) {
                        this.totalCount = this.source.totalCount = summary[0].RowCount
                        this.IPadHistory = summary
                        this.source.localdata = summary
                        this.source.totalrecords = summary[0].RowCount
                        this.dataAdapter.dataBind()
                        this.myGrid.updatebounddata()
                        this.skipCall = false
                    } else {
                        this.totalCount = this.source.totalCount = 0
                        this.source.localdata = ''
                        this.source.totalrecords = 0
                        this.dataAdapter.dataBind()
                        this.myGrid.updatebounddata()
                    }
                    this.loading = false
                },
                (error) => {
                    this.loading = false
                }
            )
        }
    }

    ngAfterViewInit(): void {
        // this.myGrid.hidecolumn('PreEnrollmentId');
    }
    ngOnInit() {
        this.loading = true
        this.memberService.PageNumber = 1
        this.memberService.PageSize = 50
        this.skipCall = true
        this.loadCurrentUser()
        this.loadIPadHistory()
    }
    iSearch() {
        if (this.myGrid !== null && this.myGrid !== undefined) {
            // Workaround to stop triggering of OnFilter and OnSort event, when filters and sort are cleared
            this.skipCall = true
            this.myGrid.clearfilters()
            this.myGrid.removesort()
        }
        this.memberService.FilterCriteria = ''
        this.memberService.SortFields = ''
        this.ngOnInit()
    }

    rendergridrows = (params: any): any[] | undefined => {
        if (!isNaN(params.startindex)) {
            this.memberService.PageNumber = Math.floor(params.startindex / this.memberService.PageSize) + 1
            if (!this.skipCall) {
                this.IPadHistory = this.gateway.GetAllIPadHistorySync(this.memberService)
                this.IPadHistory.map((row) => {
                    //row.ApplicationStartDate = moment(row.ApplicationStartDate).format('M/D/YYYY')
                    //row.ApplicationEndDate = moment(row.ApplicationEndDate).format('M/D/YYYY')
                    //row.DateCreated = moment(row.DateCreated).format('M/D/YYYY')
                })
            }
            return this.IPadHistory
        }
    }

    ready = (): void => {
        this.myGrid.localizestrings(this.jqxGridVirtualPaging.ready())
    }

    onFilter(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            let filterinfo = this.myGrid.getfilterinformation()

            this.memberService.FilterCriteria = this.jqxGridVirtualPaging.onFilter(event, filterinfo)
            let summary = this.gateway.GetAllIPadHistorySync(this.memberService)
            if (summary !== null || summary !== undefined) {
                this.IPadHistory = summary
                this.source.localdate = summary
                this.source.totalrecords = summary[0].RowCount
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
            }
            this.skipCall = false
        }
    }

    onSort(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            this.memberService.SortFields = this.jqxGridVirtualPaging.onSort(event)
            let summary = this.gateway.GetAllIPadHistorySync(this.memberService)
            if (summary !== null || summary !== undefined) {
                this.IPadHistory = summary
                this.source.localdate = summary
                this.source.totalrecords = summary[0].RowCount
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
            }
            this.skipCall = false
        }
    }

    onPageSizeChanged(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            let args = event.args
            this.source.pagesize = this.memberService.PageSize = args.pagesize
            let summary = this.gateway.GetAllIPadHistorySync(this.memberService)
            if (summary !== null || summary !== undefined) {
                summary.map((row) => {
                    //row.ApplicationStartDate = moment(row.ApplicationStartDate).format('M/D/YYYY')
                    //row.ApplicationEndDate = moment(row.ApplicationEndDate).format('M/D/YYYY')
                    //row.DateCreated = moment(row.DateCreated).format('M/D/YYYY')
                })
                this.IPadHistory = summary
                this.source.localdate = summary
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
            }
            this.skipCall = false
        }
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxGridVirtualPaging.updatefilterconditions(type)
    }

    /* calls when exportToExcel is clicked */
    exportToExcel() {
        let summary: IPadHistory[] = [] as IPadHistory[]
        //if (this.totalCount < this.chunkSize) {
        this.memberService.PageNumber = 1
        this.memberService.PageSize = this.totalCount && this.totalCount > 0 ? this.totalCount : this.chunkSize
        if (this.memberService.PageSize > 0) {
            this.loading = true
            if (this.currentUser.AetnaInd === true) {
                this.gateway.GetAllPWIPadHistory(this.memberService).subscribe(
                    (summary) => {
                        this.processIPadHistoryExportData(summary)
                    },
                    (error) => {
                        this.loading = false
                    }
                )
            } else {
                this.gateway.GetAllIPadHistory(this.memberService).subscribe(
                    (summary) => {
                        this.processIPadHistoryExportData(summary)
                    },
                    (error) => {
                        this.loading = false
                    }
                )
            }
        }
    }

    processIPadHistoryExportData(summary: IPadHistory[]) {
        if (summary.length === 0) {
            this.IsrecordFound = true
            this.serviceResponse = 'No Record Found'
            this.loading = false
        } else {
            let array = _.clone(summary)
            array.forEach(function (v) {
                delete v.RowCount
                delete v.PreEnrollmentId
            })
            let strArray = JSON.stringify(array)
            strArray = strArray.replace(/BeneficiaryName/g, 'Beneficiary Name')
            strArray = strArray.replace(/EmailAddress/g, 'Beneficiary Email')
            strArray = strArray.replace(/AgentId/g, 'Agent ID')
            strArray = strArray.replace(/ApplicationDate/g, 'Date Created')
            strArray = strArray.replace(/PlanYear/g, 'Plan Year')
            strArray = strArray.replace(/ConfirmationNumber/g, 'Confirmation Number')
            let modSummary = JSON.parse(strArray)
            let date = new Date()
            this.filename =
                'iPadEnrollmentHistory' +
                '-' +
                date.getFullYear() +
                '_' +
                (date.getMonth() + 1) +
                '_' +
                date.getDate() +
                '_' +
                date.getHours() +
                '_' +
                date.getMinutes() +
                '_' +
                date.getSeconds()
            this.excelService.exportAsExcelFileIpad(modSummary, this.filename)
            this.IsrecordFound = false
            this.loading = false
        }
    }

    downloadPDFIPad(ConfirmationNumber, PreEnrollmentId) {
        console.log(ConfirmationNumber + ' ---this is ConfirmationNumber')
        console.log(PreEnrollmentId + ' ---this is  PreEnrollmentId')
        this.memberServicePDF.ConfirmationNumber = ConfirmationNumber
        this.memberServicePDF.PreEnrollmentId = PreEnrollmentId
        var fileName = ''
        this.loading = true
        this.gateway.getPDFFileName(this.memberServicePDF.ConfirmationNumber, this.memberServicePDF.PreEnrollmentId).subscribe(
            (model: IPadPDF[]) => {
                this.IPadPDF = model
                this.gateway.downloadPDFIPad(this.memberServicePDF).subscribe(
                    (model: any) => {
                        //base64 To ArrayBuffer
                        var binaryString = window.atob(model)
                        var binaryLen = binaryString.length
                        console.log('binaryLen' + binaryLen)
                        if (binaryLen == 3) {
                            console.log('File doesnt exist / some back ground  error')
                            this.downloadError = 'File Not Found'
                            this.loading = false
                            return
                        }
                        this.downloadError = ''
                        var bytes = new Uint8Array(binaryLen)
                        for (var i = 0; i < binaryLen; i++) {
                            var ascii = binaryString.charCodeAt(i)
                            bytes[i] = ascii
                        }
                        fileName = this.IPadPDF[0].LastName + '-' + this.IPadPDF[0].FirstName + '.pdf'
                        // below code needed for ie browser
                        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                            ;(window.navigator as any).msSaveOrOpenBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                        }
                        // for other browsers
                        var link = document.createElement('a')
                        link.href = URL.createObjectURL(new Blob([bytes]))
                        link.download = fileName
                        document.body.appendChild(link)
                        this.loading = false
                        link.click()
                        // Revoking is tricky
                        // https://code.google.com/p/chromium/issues/detail?id=375297#c7
                        window.setTimeout(function () {
                            URL.revokeObjectURL(link.href)
                            document.body.removeChild(link)
                        }, 100)
                        this.loading = false
                    },
                    (error) => {
                        this.loading = false
                    }
                )
            },
            (error) => {
                this.loading = false
            }
        )
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.iSearch()
        }
    }
}
